/**
 * Pure helpers for notification bell display (icon + CSS class).
 * Kept separate from Layout so they can be unit-tested without mounting the tree.
 */

const TYPE_META = {
  project_assignment: { icon: '📋', iconClass: 'text-primary-600', itemClass: 'notification-project' },
  task_assignment: { icon: '🎯', iconClass: 'text-blue-600', itemClass: 'notification-task' },
  approval_request: { icon: '⏳', iconClass: 'text-yellow-600', itemClass: 'notification-approval' },
  weekly_hours_reminder: { icon: '⏱️', iconClass: 'text-amber-600', itemClass: 'notification-hours-warning' },
  weekly_hours_lead_summary: { icon: '📋', iconClass: 'text-violet-600', itemClass: 'notification-hours-lead' },
  weekly_hours_hr_report: { icon: '📊', iconClass: 'text-primary-600', itemClass: 'notification-hours-hr' },
};

export function getNotificationIcon(type) {
  return TYPE_META[type]?.icon || null;
}

export function getNotificationIconClass(type) {
  return TYPE_META[type]?.iconClass || 'text-secondary-500';
}

export function getNotificationClass(type, isRead) {
  if (isRead) {
    return 'notification-read hover:bg-secondary-50 dark:hover:bg-secondary-700';
  }
  return TYPE_META[type]?.itemClass || 'notification-unread';
}

export function getNotificationRoute(notif) {
  if (!notif) return null;
  if (notif.related_type === 'task' && notif.related_id) {
    return `/tasks/${notif.related_id}`;
  }
  if (notif.related_type === 'project' && notif.related_id) {
    return `/projects/${notif.related_id}`;
  }
  if (notif.type === 'approval_request') return '/team';
  if (notif.type === 'weekly_hours_reminder') return '/timesheet';
  if (
    notif.type === 'weekly_hours_lead_summary' ||
    notif.type === 'weekly_hours_hr_report'
  ) {
    return '/resource-utilization';
  }
  return null;
}
